import {useEffect, useState} from 'react';

interface IUseSetSliderImages {
  images: null | IImage[];
  mainImage: IImage;
}
const useSetSliderImages = ({images, mainImage}: IUseSetSliderImages) => {
  const [sliderImages, setSliderImages] = useState<string[]>([]);

  useEffect(() => {
    const newSliderImages: string[] = [];
    if (mainImage) {
      newSliderImages.push(mainImage.image_330);
    }
    if (images && images.length > 0) {
      images.map(image => newSliderImages.push(image.image_330));
    }
    setSliderImages(newSliderImages);
  }, [images, mainImage]);
  return {sliderImages};
};

export default useSetSliderImages;
